<template>
  <div>
    <icon name="loader" v-if="isLoading && activeElement" :style="spinnerStyle" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommonService from '@/services/CommonService';
export default {
  name: 'Spinner',
  computed: {
    ...mapState({
      isLoading: state => state.toggle.isLoading,
      activeElement: state => state.toggle.activeElement,
    }),
    spinnerStyle() {
      return CommonService.getSpinnerStyle(this.activeElement);
    },
  },
};
</script>
